import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../../shared/shared.module';
import { VRGroupService } from './vrgroup.service';
import { OrderByModule } from '../../components/order-by/order-by.module';
import { TrainListComponent } from './train-list/train-list.component';
import { QmPipesModule } from '../../components/qm-pipes/qm-pipes.module';
import { ScheduledTrainsComponent } from './scheduled-trains/scheduled-trains.component';
import { VrBaseComponent } from './base/base.component';
import { TrainFidelityDbComponent } from './dashboards/train-fidelity-db/train-fidelity-db.component';
import { NgxChartsModule, TooltipModule } from '@mipro/ngx-charts';
import { OverlayPanelModule } from '../../components/overlay-panel/overlay-panel.module';
import { ElementInfoModule } from '../../element-info/element-info.module';
import { ElementUtilsModule } from '../../element-utils/element-utils.module';
import { FiltersModule } from '../../sidebar/filters/filters.module';
import { NgbAccordionModule, NgbDatepickerModule, NgbPopoverModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ArrivingTrainsComponent } from './arriving-trains/arriving-trains.component';
import { CauseDashboardComponent } from './dashboards/cause-dashboard/cause-dashboard.component';
import { FollowTrainModule } from './follow-train/follow-train.module';
import { PercentageCircleModule } from '~app/components/percentage-circle/percentage-circle.module';
import { FontAwesomeIconsModule } from '../../fontawesome-icons.module';
import { TrainListAlarmModule } from './train-list-alarm/train-list-alarm.module';

@NgModule({
  imports: [
    ElementInfoModule,
    ElementUtilsModule,
    OrderByModule,
    OverlayPanelModule,
    TooltipModule,
    QmPipesModule,
    SharedProviderModule,
    NgxChartsModule,
    NgbAccordionModule,
    NgbTabsetModule,
    NgbPopoverModule,
    NgbDatepickerModule,
    NgbTooltipModule,
    FiltersModule,
    FollowTrainModule,
    PercentageCircleModule,
    FontAwesomeIconsModule,
    TrainListAlarmModule
  ],
  exports: [
    VrBaseComponent, TrainListComponent, ScheduledTrainsComponent, TrainFidelityDbComponent,
    ArrivingTrainsComponent, CauseDashboardComponent
  ],
  declarations: [
    TrainListComponent, ScheduledTrainsComponent, VrBaseComponent, TrainFidelityDbComponent,
    ArrivingTrainsComponent, CauseDashboardComponent,
  ],
  providers: [
    VRGroupService
  ]
})
export class VrgroupModule {
}
